<template>
  <div
    class="duration-500 flex flex-col items-center justify-center p-8 transition-all"
    :class="[
      fullScreen
        ? 'fixed inset-0 z-(--z-index-ds-loader) bg-surface-canvas/80 dark:bg-surface-level-950/80 backdrop-blur-md'
        : 'w-full h-full'
    ]"
  >
    <div class="group relative">
      <div class="absolute animate-pulse bg-primary blur-3xl inset-0 opacity-20 scale-150" />

      <div
        class="bg-surface-canvas border border-border-level-100 dark:bg-surface-level-900 dark:border-border-level-800 flex h-28 items-center justify-center mx-auto relative rounded-[2.5rem] shadow-2xl shadow-primary/10 w-28"
      >
        <Loader2Icon
          class="animate-spin h-14 text-primary w-14"
          stroke-width="1.5"
        />
      </div>
    </div>

    <div class="flex flex-col h-12 items-center justify-start mt-8">
      <h3
        v-if="title"
        class="dark:text-content-inverse font-bold text-content-level-900 text-xl tracking-tight"
      >
        {{ title }}
      </h3>

      <p
        v-if="description"
        class="dark:text-content-level-400 font-medium mt-2 text-content-level-500 text-sm"
      >
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Loader2Icon } from '@lucide/vue'
import { computed } from 'vue'
import { usePresentationTranslator } from '~/composables/usePresentationTranslator'

interface Props {
  /** Loading heading. */
  title?: string
  /** Loading supporting text. */
  description?: string
  /** Whether the loader fills the viewport. */
  fullScreen?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  description: '',
  title: 'Loading...'
})

const t = usePresentationTranslator()

const description = computed(() => props.description || t('common.loading.description'))
</script>
